// constants.ts
// Default color palette values and color group configurations

import { PaletteStructure} from './types';

export const DEFAULT_PALETTE_STRUCTURE: PaletteStructure = {
  colors: {
    background: '#ffffff',
    surface: '#f5f5f5',
    surfaceElevated: '#fafafa',
    
    primary: '#2563eb',
    primaryLight: '#60a5fa',
    primaryDark: '#1e40af',
    
    secondary: '#7c3aed',
    secondaryLight: '#a78bfa',
    secondaryDark: '#5b21b6',
    
    accent: '#ec4899',
    accentLight: '#f9a8d4',
    accentDark: '#be185d',
    
    text: '#1f2937',
    textPrimary: '#111827',
    textSecondary: '#6b7280',
    textTertiary: '#9ca3af',
    
    border: '#e5e7eb',
    borderLight: '#f3f4f6',
    
    error: '#ef4444',
    errorLight: '#fca5a5',
    errorDark: '#dc2626',
    
    success: '#10b981',
    successLight: '#86efac',
    successDark: '#059669',
    
    warning: '#f59e0b',
    warningLight: '#fcd34d',
    warningDark: '#d97706',
  },
  groups: [
    {
      title: 'Base Colors',
      colors: ['background', 'surface', 'surfaceElevated']
    },
    {
      title: 'Primary',
      colors: ['primary', 'primaryLight', 'primaryDark']
    },
    {
      title: 'Secondary',
      colors: ['secondary', 'secondaryLight', 'secondaryDark']
    },
    {
      title: 'Accent',
      colors: ['accent', 'accentLight', 'accentDark']
    },
    {
      title: 'Text',
      colors: ['text', 'textPrimary', 'textSecondary', 'textTertiary']
    },
    {
      title: 'Feedback',
      colors: ['error', 'errorLight', 'errorDark', 'success', 'successLight', 'successDark', 'warning', 'warningLight', 'warningDark']
    },
    {
      title: 'Border',
      colors: ['border', 'borderLight']
    }
  ]
};

// Legacy export for backwards compatibility
export const DEFAULT_COLOR_PALETTE = DEFAULT_PALETTE_STRUCTURE.colors;
export const COLOR_GROUPS = DEFAULT_PALETTE_STRUCTURE.groups;